module.exports = __webpack_public_path__ + "static/media/clone.8596382d.svg";